import { Fragment } from "react";
import { Transition } from "@headlessui/react";

export type ProgressProp = {
  open: boolean;
  progressNum: number;
  color?: "blue" | "green" | "red" | "yellow" | "indigo" | "purple" | "pink" | "gray";
  text?: string;
  subText?: string;
};

export const Progress = ({
  open,
  progressNum,
  color="indigo",
  text="loading...",
  subText
}: ProgressProp) => {
  return (
    <Transition.Root show={open} as={Fragment}>
      <div className="fixed inset-0 z-10 overflow-y-auto bg-black/50">
        <div className="flex flex-col min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div className={`text-white`}>{subText}</div>
            <div className="w-1/4 bg-white rounded-md dark:bg-gray-700 border-2 border-white">
              <div
                className={`bg-${color}-600 text-xs font-medium text-${color}-100 text-center p-2 leading-none rounded animate-pulse`}
                style={{width: `${progressNum}%`}}>
                  {progressNum}%
              </div>
            </div>
          <div className={`animate-ping text-white`}>{text}</div>
        </div>
      </div>
    </Transition.Root>
  );
};

